import { uniq, cloneDeep } from 'lodash'

// Create a two dimensional hash lookup and detect clashes
export const checkOverlapping  = (items) => {
  let hash_lookup = {};
  
  let overlapping = { state: false, schedules: []};
  
  for (let i = 0; i < items.length; i++) {
      let item = items[i];
      
      let start_duration = item.duration/3600;
      let cloned_start = cloneDeep(item.dtstart);
      
      for (let i = 0; i < start_duration; i++) {
          cloned_start.setTime(cloned_start.getTime() + (3600*1000));
          let hash = `${cloned_start.getMonth()}_${cloned_start.getDate()}_${cloned_start.getHours()}`;
          
          if (typeof hash_lookup[hash] === 'undefined') {
            hash_lookup[hash] = { state: true, id: item.id };
          } else if (hash_lookup[hash].state) {
            overlapping.state = true;
            overlapping.schedules.push(item.id);
            overlapping.schedules.push(hash_lookup[hash].id);
          }
      }
  }

  overlapping.schedules = uniq(overlapping.schedules);
  return overlapping;
}